<template>
  <div
    class="shop-finder"
    :class="[theme ? `shop-finder--${theme}` : '', spaces ? 'shop-finder--spaces' : '']"
  >
    <h2
      v-if="title"
      class="text--center shop-finder__title"
    >
      {{ title }}
    </h2>
    <form
      method="get"
      target="_blank"
      action="https://shopsuche.telekomshop.de/?"
      class="shop-finder__form"
    >
      <div class="shop-finder__content">
        <input
          type="hidden"
          name="onlyTsg"
          value="true"
        />
        <label
          for="shop-finder-address"
          class="sr-only"
          >Adresse</label
        >
        <input
          id="shop-finder-address"
          class="input"
          :class="[theme ? `shop-finder__input--${theme}` : 'shop-finder__input']"
          :placeholder="placeholder"
          name="address"
          type="text"
        />
        <button
          type="submit"
          :class="[theme ? `shop-finder__btn--${theme}` : '']"
          class="btn btn--transparent btn--borderless shop-finder__btn"
          aria-label="Shop suchen"
          @click="$tealium.link('content.button.shop-finden')"
        >
          <SvgIcon
            :class="[theme ? `shop-finder__icon--${theme}` : '']"
            :image="searchIcon"
            class="icon shop-finder__icon"
          />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import searchIcon from '@/assets/images/navigation/search.svg';

export default {
  name: 'ShopFinder',
  props: {
    title: {
      type: String,
      default: '',
    },
    spaces: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Ort, Straße/Hausnummer',
    },
  },
  data() {
    return {
      searchIcon,
    };
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.shop-finder {
  &--spaces {
    padding-top: 4 * $grid-base;
    padding-bottom: 4 * $grid-base;
    @include mq($mq-md) {
      padding-bottom: 7 * $grid-base;
    }
  }
  &--footer {
    position: relative;
    clear: both;
  }
  &__form {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__content {
    position: relative;
    width: 100%;
    max-width: 460px;
  }
  &__icon {
    width: 14px;
    height: 22px;
    color: color(grey, 16000);
    &--footer {
      color: var(--color-secondary);
    }
  }
  &__input {
    width: 100%;
    &--footer {
      background-color: color(grey, 13000);
      border: 1px solid var(--color-secondary);
      color: var(--color-secondary);
      width: 100%;
      &::-moz-placeholder {
        color: var(--color-secondary);
        opacity: 1;
      }
      &:-ms-input-placeholder {
        color: var(--color-secondary);
      }
      &::-webkit-input-placeholder {
        color: var(--color-secondary);
      }

      &:hover,
      &:focus,
      &:active {
        background-color: color(grey, 11000);
        color: var(--color-secondary);
      }
    }
    // Default Need to override
    &.input {
      height: auto;
      padding: 1.5 * $grid-base 2 * $grid-base;
    }
  }
  &__btn {
    position: absolute;
    transform: translateY(-50%);
    right: 10px;
    top: 50%;
    padding: 5px 10px;
    &:hover {
      background-color: transparent;
    }
    &--footer {
      right: 0;
    }
  }
}
</style>
